import { utcToZonedTime } from "date-fns-tz";

export const getZonedDate = () => {
  const curDate = new Date();
  const timeZone = "America/New_York";
  return utcToZonedTime(curDate, timeZone);
};
